import { FC } from 'react';
import { Page } from '@/components/Page.tsx';
import { Headline, Spinner, Caption } from '@telegram-apps/telegram-ui';
import { useTranslation } from 'react-i18next';
import { useSecretSanta } from '@/providers/SecretSantaProvider.tsx';
import { useNavigation } from '@/providers/NavigationProvider.tsx';
import { SecretSantaGameForm } from '@/components/SecretSanta/SecretSantaGameForm.tsx';
import { SecretSantaGame } from '@/api/types.ts';

export const EditSecretSantaGamePage: FC = () => {
  const { game, isLoading } = useSecretSanta();
  const { t } = useTranslation();
  const { navigateToRoute } = useNavigation();

  const handleGameSaved = (updatedGame: SecretSantaGame) => {
    navigateToRoute(`/main/secret-santa/${updatedGame.id}`, true);
  };

  if (isLoading) {
    return (
      <Page>
        <div className="flex justify-center items-center p-10">
          <Spinner size="l" />
        </div>
      </Page>
    );
  }

  if (!game) {
    return (
      <Page>
        <div className="p-10 text-center">
          <Caption className="text-color-hint">{t('secretSanta.error.loadFailed')}</Caption>
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <div className="p-3 pb-10">
        <Headline className="pl-2 text-center mb-4" weight="2">
          {t('secretSanta.actions.edit')}
        </Headline>
        <SecretSantaGameForm game={game} onSaved={handleGameSaved} />
      </div>
    </Page>
  );
};
